import React, { useState } from 'react';
import {
  Box,
  TextField,
  IconButton,
  Chip,
  Stack,
  Typography
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Control, useFieldArray, useWatch } from 'react-hook-form';

interface StringArrayInputProps {
  control: Control<any>;
  name: string;
  label: string;
  placeholder?: string;
}

export const StringArrayInput: React.FC<StringArrayInputProps> = ({
  control,
  name,
  label,
  placeholder = 'Add item'
}) => {
  const [newValue, setNewValue] = useState('');
  const { fields, append, remove } = useFieldArray({
    control,
    name
  });
  
  // Watch the values to display correct label
  const values = useWatch({
    control,
    name
  });

  const handleAdd = () => {
    if (newValue.trim()) {
      append(newValue.trim());
      setNewValue('');
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>{label}</Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <TextField
          size="small"
          label={placeholder}
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAdd();
            }
          }}
          fullWidth
        />
        <IconButton onClick={handleAdd} color="primary" disabled={!newValue.trim()}>
          <AddIcon />
        </IconButton>
      </Stack>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {fields.map((field, index) => (
          <Chip
            key={field.id}
            label={values?.[index] || ''}
            onDelete={() => remove(index)}
          />
        ))}
      </Box>
    </Box>
  );
};
